<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 512 512" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path d="M484.9 72.9v366.2c0 12.6-13.3 22.9-29.9 22.9H335.7v-62.6h72.6c5.9 0 11.6-1.8 15.7-5s6.5-7.5 6.5-12.1v-6.8c0-4.5-2.3-8.9-6.5-12.1-4.2-3.2-9.8-5-15.7-5h-72.6v-41h72.6c5.9 0 11.6-1.8 15.7-5s6.5-7.5 6.5-12.1v-6.8c0-4.5-2.3-8.9-6.5-12.1-4.2-3.2-9.8-5-15.7-5h-72.6v-41h72.6c5.9 0 11.6-1.8 15.7-5 4.2-3.2 6.5-7.5 6.5-12.1v-6.8c0-4.5-2.3-8.9-6.5-12.1s-9.8-5-15.7-5h-72.6v-41h72.6c5.9 0 11.6-1.8 15.7-5 4.2-3.2 6.5-7.5 6.5-12.1v-6.8c0-4.5-2.3-8.9-6.5-12.1s-9.8-5-15.7-5h-72.6V50H455c16.5 0 29.9 10.2 29.9 22.9z" fill="#e6e6e6" />
      <path d="M44.2 47.2 294.7 6.1c2.9-.5 5.7.5 7.9 2.7s3.4 5.3 3.4 8.6v477.1c0 3.3-1.2 6.5-3.4 8.6-2.2 2.2-5 3.2-7.9 2.7l-250.4-41c-9.8-1.6-17.1-11.3-17.1-22.7V69.9c-.1-11.4 7.2-21.1 17-22.7z" fill="#1abb9c" />
      <path d="M141.6 210.2z" fill="#f05264" />
      <path d="M430.6 375.5v6.8c0 4.5-2.3 8.9-6.5 12.1s-9.8 5-15.7 5h-72.6v-41h72.6c5.9 0 11.6 1.8 15.7 5s6.5 7.5 6.5 12.1zm0-82v6.8c0 4.5-2.3 8.9-6.5 12.1s-9.8 5-15.7 5h-72.6v-41h72.6c5.9 0 11.6 1.8 15.7 5 4.1 3.3 6.5 7.6 6.5 12.1zm0-81.9v6.8c0 4.5-2.3 8.9-6.5 12.1-4.2 3.2-9.8 5-15.7 5h-72.6v-41h72.6c5.9 0 11.6 1.8 15.7 5s6.5 7.6 6.5 12.1zm0-81.9v6.8c0 4.5-2.3 8.9-6.5 12.1-4.2 3.2-9.8 5-15.7 5h-72.6v-41h72.6c5.9 0 11.6 1.8 15.7 5s6.5 7.6 6.5 12.1z" fill="#b8b8b8" />
      <path d="m195.8 255.4 68.4-114-57.3 3.1-34.8 68.5c-1.9 3-3.2 6.2-4 9.6-.5 3.3-1.4 6.5-2.8 9.6-.6-3.3-1.4-6.7-2.4-9.9-.8-3.1-2-6.1-3.6-8.9l-31.6-63-55.4 2.7 59.3 103.4-64.3 104.4 53.8 2.4 36-68.5v-7.5c.4 1.9 1.2 3.8 2.4 5.5l39.6 72.9 6.3 1.4 60.5 3.4-70.1-115.1zm-38.7 28.8a5.1 5.1 0 0 1 0-4.8v4.8z" fill="#fff" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
